<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'PBRInterfaceList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              PBR Interface
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">PBR Interface</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PBRInterface">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">Audra Name</label>
                    <multiselect
                      v-model="value.accountId"
                      :options="audraName.map(o => o.id)"
                      :custom-label="
                        opt => {
                          let z = audraName.find(x => x.id == opt)
                          return z ? z.device_name : ''
                        }
                      "
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('accountId')"
                    >
                      {{ errors.first('accountId') }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Available Interface</label>
                    <multiselect
                      v-model="value.interface_name"
                      :options="Object.keys(pre.interface)"
                      :custom-label="opt => pre.interface[opt]"
                      placeholder="Select Available Interface"
                      :searchable="true"
                      :multiple="false"
                      id="interface_name"
                      v-bind:class="{
                        'has-error': errors.has('interface_name')
                      }"
                      v-validate="'required'"
                      name="interface_name"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('interface_name')"
                    >
                      {{ errors.first('interface_name') }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">PBR-Map Name</label>
                    <multiselect
                      v-model="value.pbr_map_id"
                      :options="Object.keys(pre.pbrNames)"
                      :custom-label="opt => pre.pbrNames[opt]"
                      placeholder="Select PBR-Map Name"
                      :searchable="true"
                      :multiple="false"
                      id="pbr_map_id"
                      v-bind:class="{ 'has-error': errors.has('pbr_map_id') }"
                      v-validate="'required'"
                      name="pbr_map_id"
                    >
                    </multiselect>

                    <div
                      class="help text-danger"
                      v-show="errors.has('pbr_map_id')"
                    >
                      {{ errors.first('pbr_map_id') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from '@/services/api'
import axios from 'axios'
import LocalStorage from "@/services/localStorage";

export default {
  name: 'PBRInterfaceForm',
  metaInfo: {
    title: 'PBR Interface | Dotlines'
  },
  components: {},

  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      interface: {
        eth0: 'ETH-1',
        eth1: 'ETH-2',
        eth2: 'ETH-3',
        eth3: 'ETH-4',
        eth4: 'ETH-5',
        eth5: 'ETH-6',
        wan: 'WAN',
        'br-lan': 'LAN'
      },
      pbrNames: []
    },
    audraName: []
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/pbr_interfaces'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/pbr_interfaces/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'PBRInterfaceList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/pbr_interfaces/' + id
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },

    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(errors => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          })
      }

      await CommonAPI.getAudraName(this.hardCodedAcNumber)
        .then(response => {
          this.audraName = response
        })
        .catch(error => {
          console.log(error.response)
        })

      await this.getPBRNames()
        .then(response => {
          this.pre.pbrNames = response.data
        })
        .catch(error => {
          console.log(error.response)
        })

      this.is_loading = false
    },

    getPBRNames: function () {
      return new Promise((resolve, reject) => {
        axios
          .get('/pbr-map-names', {
            params: {
              accountId: 3
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {})
      })
    }
  },

  mounted () {
    this.initialize()
  }
}
</script>
